<div #tooltipMenu class="tooltip-menu" [class.show]="isMenuOpen">
  <ng-content></ng-content>
</div>
